/* Table Column Sort And Filter Header Directive
 *
 * Angular Module: trackerbase-app.directives.sort-filter-column-header
 * Exposed directive name: tbSortFilterColumnHeader
 * Directive exposed as "tb-sort-filter-column-header" element.
 *
 */

import angular from "angular";

import Assert from "tbAssert";

function strFieldHasValidContent(fieldValue) {
    return ((fieldValue != null) &&
            (angular.isString(fieldValue)) &&
            (fieldValue.length > 0));
}

const mLogSvc = new WeakMap();

class SortFilterColumnHeaderComponentController {
    constructor($scope, $log) {

        Assert.StrictAssert($scope != null, "Assertion Failure: Missing Controller Scope Service Dependency");
        Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");

        mLogSvc.set(this, $log);

        this.columnFilterContent = null;
        this.columnSortReverse = null;

        this.showFilterControl = false;

        $scope.$watch(
            () => this.sortEnabled,
            (newVal, oldVal) => {
                if (newVal !== oldVal) {
                    if (this.sortEnabled !== true) {
                        this.sortReversed = null;
                        this.columnSortReverse = null;
                    }
                    else {
                        this.sortReversed = this.columnSortReverse;
                    }
                }
            }
        );

        $scope.$watch(() => this.showFilter,
            (newVal, oldVal) => {
                if (newVal !== oldVal)
                {
                    this.showFilterControl = this.showFilter;
                }
            }
        );
    }

    $onInit() {
        this.columnFilterContent = this.filterContent;
        this.columnSortReverse = this.sortEnabled ? this.sortReversed : null;
        this.showFilterControl = this.showFilter;
    }

    onFilterChange() {
        this.filterContent =
            strFieldHasValidContent(this.columnFilterContent) ?
                this.columnFilterContent :
                null;
    }

    sortToggle() {
        if (this.columnSortReverse == null) {
            this.columnSortReverse = false;
        }
        else {
            this.columnSortReverse = !this.columnSortReverse;
        }

        this.sortEnabled = (this.columnSortReverse != null);
        this.sortReversed = this.sortEnabled ? this.columnSortReverse : null;

        mLogSvc.get(this).debug(
            `Sort Enabled: ${(this.sortEnabled ? "Yes" : "No")} Sort Reversed: ${(this.sortReversed ? "Yes" : "No")}`
        );
    }
}

SortFilterColumnHeaderComponentController.$inject = [ "$scope", "$log" ];

const sortFilterColumnHeaderTemplate = require("./SortFilterColumnHeader.tpl.html");

const SortFilterColumnHeaderComponent = {
    name: "tbSortFilterColumnHeader",
    config: {
        template: sortFilterColumnHeaderTemplate,
        bindings: {
            filterContent: "=tbFilterContent",
            showFilter: "<tbShowFilter",
            sortEnabled: "=tbSortEnabled",
            sortReversed: "=tbSortReversed",
            filterPlaceHolderText: "@tbFilterPlaceHolderText"
        },
        controller: SortFilterColumnHeaderComponentController,
        controllerAs: "sortFilterHeader",
        transclude: true
    }
};

export default angular
    .module("trackerbase-app.directives.sort-filter-column-header", [
        "ngSanitize",
        "ngAnimate",
        "ngAria",
        "ui.bootstrap"
    ])
    .component(SortFilterColumnHeaderComponent.name, SortFilterColumnHeaderComponent.config)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/directives/SortFilterColumnHeader.js
// module id = 7Hbk
// module chunks = 1